import styled from 'styled-components';
import Button from '../Button/Button.es.js';
var SubAction = styled(Button).attrs(function () {
  return {
    variant: "subtle",
    kind: "link",
    size: "sm"
  };
}).withConfig({
  componentId: "sc-12km6yv-0"
})([""]);
SubAction.displayName = "FeatureCard.SubAction";
export { SubAction };